<!--
作者：小明哥
组件：首页-按类型分类的视频
框架：VUE、vue-router、vuex、axios、ElementUI等
脚手架：VUE CLI3
-->
<template>
    <div class="develop-video-content">
        <!--标题显示-->
        <div class="public-content-header">
            <div class="public-content-header-left" v-if="courseTypeItem.courseTypeName">
                <p>{{courseTypeItem.courseTypeName}}</p>
            </div>
            <div class="public-content-header-right flex">
                <slot></slot>
                <p class="gray-9">
                    <router-link :to="moreUrl">查看更多课程>></router-link>
                </p>
            </div>
        </div>

        <!--大屏幕显示-->
        <div class="home-video-content">
            <el-card class="el-card" :body-style="{ padding: '0px'}">
                <div class="home-video-type-index">
                    <div class="list-item" :style="{backgroundColor,overflow:'hidden',marginTop:'0px'}"
                         @click="toCourseDetail(IndexModel)">
                        <img v-if="IndexModel.courseImg"
                             :src="IndexModel.courseImg | imgUrl"
                             height="100%" style="opacity:0.08;">
                        <div class="video-title">
                            <div class="name">{{IndexModel.courseName}}</div>
                            <div class="create-time">发布时间：{{IndexModel.createTime | dateFormat}}</div>
                            <div class="create-time">学习人数：{{IndexModel.studyNumber | number}}</div>
                            <div class="tag" v-for="(item,index) in comm.tags(IndexModel.tag)" :key="index">
                                {{item}}
                            </div>
                            <el-rate
                                    v-model="IndexModel.value"
                                    disabled
                                    show-score
                                    text-color="#ff9900"
                                    score-template="{value}">
                            </el-rate>
                        </div>
                    </div>
                    <div class="develop-detail-content-right" style="padding: 0 2px 0 10px">
                        <div :class="{TypeVideoScroll:IndexCourseChapterList.length>5}">
                            <div class="right-item" v-for="(item,index) in IndexCourseChapterList"
                                 :key="index">
                                <div class="item-info">
                                    <div class="gray3" @click="toCourseDetail(IndexModel,item)"><span
                                            class="free">P{{item.courseChapterSort}}</span>
                                        {{item.courseChapterName}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </el-card>

            <!--6个列表数据显示-->
            <div class="develop-video-list" style="width: 895px;justify-content: space-between;">
                <div class="list-item home-list-item" style="margin: 0 0 15px 0" v-for="(item,index) in list"
                     :key='index'>
                    <div class="item-img" @click="toCourseDetail(item)">
                        <img v-if="item.courseImg" :src="item.courseImg | imgUrl" alt="">
                        <div class="item-img-modal">
                            <img style="border-radius: 5px;" src="../assets/img/develop/develop-play.png"
                                 :alt="item.courseTypeName +'-'+item.courseName">
                        </div>
                        <p class="video-time">{{item.createTime | dateFormat}}</p>
                    </div>
                    <p class="item-name" style="color: #909399;">{{item.courseTypeName}} [{{item.courseCategoryName | courseCategoryNameDes}} ]</p>
                    <p class="item-name">{{item.courseName}}</p>
                    <p class="item-study">
                        <span class="item-free">免费</span>
                        <span v-if="item.studyNumber==0"></span>
                        <span v-else>{{item.studyNumber | number}}人学</span>
                    </p>
                </div>
                <slot name="gg"></slot>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: "HomeTypeVideoComm",
        props: {
            courseTypeItem:{
                type: Object,
                default: null
            }
        },
        data() {
            return {
                //列表
                list: [],
                //默认背景色
                backgroundColor:'rgba(159,210,252,0.99)',
                //连接：更多
                moreUrl: null,
                //大屏幕对象
                IndexModel: {},
                //对应的课程章节
                IndexCourseChapterList:[],
                //评份（预留）
                value: 3.5
            }
        },
        created() {
            //是否初始化数据
            this.init();
        },
        methods: {
            init() {
                //查询类型列表
                this.getData();
                //更多链接
                this.moreUrl = "/course?courseTypeId=" + this.courseTypeItem.courseTypeId;
            },

            /**
             * 获取页面数据,支持直接传参数
             */
              getData() {
                console.log("开始查询,类型ID:" + this.courseTypeItem.courseTypeId);
                //url
                let url = `/web/webHomeTypeIndex/typeIndexList/${this.courseTypeItem.courseTypeId}`;
                console.log("========getData======>>",url)
                //查询
                this.comm.getBaseListApi(url,data=>{
                    this.list = data;
                    console.log("查询结果：",this.list)
                    //找大图展示数据
                    this.getIndexModel();
                });
            },

            /**
             * 找大图展示数据
             */
            getIndexModel() {
                this.IndexModel = this.list.find(item=>item.typeIndex === 1);
                console.log("查询IndexModel结果：",this.IndexModel)
                //查询章节
                if(this.IndexModel){
                    //设置背景色
                    if(this.IndexModel.bgColor){
                        this.backgroundColor = this.IndexModel.bgColor
                    }
                    //加载章节内容
                    let url = `/web/courseChapter/byCourseId/${this.IndexModel.courseId}`;
                    this.comm.getBaseListApi(url,data=>this.IndexCourseChapterList = data);
                }
            },

            /**
             * 详情页跳转
             * @param vid
             */
            toCourseDetail(item, courseChapter) {
                let courseChapterId = courseChapter ? courseChapter.courseChapterId : 0;
                window.open(`/courseDetail/${item.courseId}/${courseChapterId}`);
            }
        }
    }
</script>

<style scoped>
    .el-card {
        border: 0px;
        background-color: #FFF;
        color: #303133;
        transition: .3s;
        height: 595px;
        margin-right: 15px;
    }

    .video-title {
        line-height: 35px;
        margin-top: -500px;
        padding: 0 20px;
    }

    .video-title .name {
        font-size: 18px;
        margin-bottom: 20px;
        font-weight: bold;
        color: #404040;
    }

    .video-title .create-time {
        font-size: 15px;
        font-weight: bold;
        color: #fdfdfd;
        font-style: oblique;
    }

    /*课程滚动条设置*/
    .TypeVideoScroll {
        height: 200px;
        overflow: auto;
    }

    .TypeVideoScroll::-webkit-scrollbar {
        width: 2px;
        height: 6px;
    }

    /*正常情况下滑块的样式*/

    .TypeVideoScroll::-webkit-scrollbar-thumb {
        background-color: rgba(0, 0, 0, .05);
        border-radius: 3px;
        -webkit-box-shadow: inset 1px 1px 0 rgba(0, 0, 0, .1);
    }

    /*鼠标悬浮在该类指向的控件上时滑块的样式*/

    .TypeVideoScroll:hover::-webkit-scrollbar-thumb {
        background-color: rgba(0, 0, 0, .2);
        border-radius: 3px;
        -webkit-box-shadow: inset 1px 1px 0 rgba(0, 0, 0, .1);
    }

    /*鼠标悬浮在滑块上时滑块的样式*/

    .TypeVideoScroll::-webkit-scrollbar-thumb:hover {
        background-color: rgba(0, 0, 0, .4);
        -webkit-box-shadow: inset 1px 1px 0 rgba(0, 0, 0, .1);
    }

    /*正常时候的主干部分*/

    .TypeVideoScroll::-webkit-scrollbar-track {
        border-radius: 3px;
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
        background-color: white;
    }

    /*鼠标悬浮在滚动条上的主干部分*/

    .TypeVideoScroll::-webkit-scrollbar-track:hover {
        -webkit-box-shadow: inset 0 0 3px rgba(0, 0, 0, .3);
        background-color: rgba(0, 0, 0, .01);
    }

</style>
